import FormCommand from '../../components/controls/FormCommand/FormCommand';
import classes from './credit-officer-form.module.css';

export interface CreditOfficerFormProps { }

function CreditOfficerForm(props: CreditOfficerFormProps) {

	return (
		<div className='row'>
			<div className="col-7">
				<h3>Credit Officer</h3>

				<div className="form-group">
					<label htmlFor="name" className='control-label'>Credit Officer Name</label>
					<input type="text" name="name" id="name" className='form-control' />
				</div>

				<FormCommand />
			</div>
		</div>
	);
}

export default CreditOfficerForm;